WiseMetering.Views.EditNetmoreIntegration = WiseMetering.Views.Modal.Save.extend({
    className: 'mbx-info text-left',
    form_prefix: 'integration',
    template: 'templates/integrations/netmore/edit',
    title: () => i18next.t('modal.title.integrations.edit'),

    getFormData: function() {
        const data = this.formSerializer();

        // A cleared field would reach the API as '' and fail the numericality check,
        // so it is dropped instead and the current rate is kept.
        if (data.reference_rate) {
            data.reference_rate = parseInt(data.reference_rate, 10);
        } else {
            delete data.reference_rate;
        }

        return data;
    }
});
